var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInterrogation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4973_3375",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4973_3375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2001 32C21.2001 29.3 21.4421 27.358 21.9261 26.174C22.4088 24.9913 23.4334 23.7 25.0001 22.3C26.3668 21.1 27.4081 20.058 28.1241 19.174C28.8414 18.2913 29.2001 17.2833 29.2001 16.15C29.2001 14.7833 28.7421 13.65 27.8261 12.75C26.9088 11.85 25.6334 11.4 24.0001 11.4C22.3001 11.4 21.0081 11.9167 20.1241 12.95C19.2414 13.9833 18.6168 15.0333 18.2501 16.1L13.1001 13.9C13.8001 11.7667 15.0834 9.91667 16.9501 8.35C18.8168 6.78333 21.1668 6 24.0001 6C27.5001 6 30.1921 6.97533 32.0761 8.926C33.9588 10.8753 34.9001 13.2167 34.9001 15.95C34.9001 17.6167 34.5421 19.042 33.8261 20.226C33.1088 21.4087 31.9834 22.75 30.4501 24.25C28.8168 25.8167 27.8254 27.008 27.4761 27.824C27.1254 28.6413 26.9501 30.0333 26.9501 32H21.2001ZM24.0001 44C22.9001 44 21.9588 43.6087 21.1761 42.826C20.3921 42.042 20.0001 41.1 20.0001 40C20.0001 38.9 20.3921 37.958 21.1761 37.174C21.9588 36.3913 22.9001 36 24.0001 36C25.1001 36 26.0421 36.3913 26.8261 37.174C27.6088 37.958 28.0001 38.9 28.0001 40C28.0001 41.1 27.6088 42.042 26.8261 42.826C26.0421 43.6087 25.1001 44 24.0001 44Z",
    fill: "#ACACAC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterrogation);
export default __webpack_public_path__ + "static/media/interrogation.449f4738.svg";
export { ForwardRef as ReactComponent };